import dynamic from 'next/dynamic';
import { BetAmountInputButtonsProps } from './props';
import { SettingLayoutComponentId } from '@starsoft/common/models';
import { useBetAmountInputSetting } from '@/hooks/games/useBetAmountInputSetting';

const BetAmountInputButtonsV1 = dynamic(import('./V1'), { ssr: true });
const BetAmountInputButtonsV2 = dynamic(import('./V2'), { ssr: true });

export default function BetAmountInputButtons({
  version,
  ...props
}: BetAmountInputButtonsProps): JSX.Element {
  const { version: componentVersion } = useBetAmountInputSetting();
  const coallescedVersion = version ?? componentVersion;

  switch (coallescedVersion) {
    case SettingLayoutComponentId.BetAmountInputV1:
    case SettingLayoutComponentId.BetAmountInputV2:
      return <BetAmountInputButtonsV1 version={version} {...props} />;
    case SettingLayoutComponentId.BetAmountInputV3:
    case SettingLayoutComponentId.BetAmountInputV4:
      return <BetAmountInputButtonsV2 version={version} {...props} />;
    default:
      return <BetAmountInputButtonsV1 version={version} {...props} />;
  }
}
